/* eslint-disable react/require-default-props,react/forbid-prop-types */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { ROUTE_COURSE_PAGE } from '../../../../../ReduxStorage/routeActions';

import { Link } from '../../../../containers/Link/index';

class LinkIcon extends PureComponent {
  static propTypes = {
    icon: PropTypes.string,
  };

  render = () => {
    const { icon } = this.props;
    if (icon) {
      return (
        <span className={classNames('course-link-icon', `icon-${icon}`)} />
      );
    }
    return null;
  };
}

export class LinkContents extends PureComponent {
  static propTypes = {
    link: PropTypes.any.isRequired,
    courseCode: PropTypes.string.isRequired,
    institutionPath: PropTypes.string,
    children: PropTypes.node.isRequired,
  };

  render() {
    const {
      link,
      courseCode,
      institutionPath,
      children,
      ...otherProps
    } = this.props;

    if (link.get('external')) {
      return <a href={link.get('url')}>{children}</a>;
    } else if (link.get('courseSubPath') || link.get('courseSubPath') === '') {
      return (
        <Link
          to={{
            type: ROUTE_COURSE_PAGE,
            params: {
              courseCode,
              subPath: link.get('courseSubPath') || undefined,
            },
            state: institutionPath
              ? {
                  institutionPrefix: institutionPath,
                }
              : {},
          }}
          {...otherProps}
        >
          {children}
        </Link>
      );
    } else {
      // This confusing case is for thins like progress pages etc,
      // which are not external, but are also not under the course path.
      return (
        <a href={`/${link.get('pagePath')}`} {...otherProps}>
          {children}
        </a>
      );
    }
  }
}

export class CoursePageLink extends PureComponent {
  static propTypes = {
    link: PropTypes.any.isRequired,
    currentModuleSet: PropTypes.string,
    courseCode: PropTypes.string.isRequired,
    institutionPath: PropTypes.string,
  };

  render() {
    const { link, currentModuleSet, courseCode, institutionPath } = this.props;
    const isInUse = link.get('inUse') && !currentModuleSet;

    return (
      <li
        key={link.get('index')}
        className={classNames('item', {
          'in-use': isInUse,
        })}
      >
        <LinkContents
          link={link}
          courseCode={courseCode}
          institutionPath={institutionPath}
          aria-current={isInUse ? 'page' : null}
        >
          <LinkIcon icon={link.get('icon')} />
          {link.get('name')}
        </LinkContents>
      </li>
    );
  }
}
